// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"386":"6a4ac952","455":"868abfbd","620":"6dbc9181","640":"27d5d511","644":"c71d32b4","706":"1c771ac6","770":"1ab30a5f","955":"b442b6cd"}[chunkId] + ".chunk.js";
};